import React, { useEffect, useRef } from 'react';
import VanillaTilt from 'vanilla-tilt';
import { Employee } from '../../das-finsuite/ea-huddle-v2/interfaces/interface';
import { USER_BADGE_PHOTO_FULLSIZE_URL, generatePhoneToolUrl } from '../../../constants/AppConstants';
import { formatStateName } from '../../das-finsuite/ea-huddle-v2/utils/employeeUtils';
import './HyperBadge.scss';

interface HyperBadgeProps {
  employee: Employee;
}

const BADGE_COLOR_MAP: Record<string, string> = {
  blue: 'blue',
  orange: 'yellow',
  yellow: 'yellow',
  red: 'red',
  purple: 'purple',
  silver: 'silver',
  gold: 'gold'
};

const tiltOptions = {
  reverse: false,
  max: 15,
  perspective: 1000,
  scale: 1.05,
  speed: 300,
  transition: true,
  axis: null,
  reset: true,
  easing: 'cubic-bezier(.03,.98,.52,.99)',
  glare: true
};

export const HyperBadge: React.FC<HyperBadgeProps> = ({ employee }) => {
  const badgeRef = useRef<HTMLDivElement>(null);
  const color = employee.badgeColor ? BADGE_COLOR_MAP[employee.badgeColor] || 'blue' : 'blue';
  const photo = `${USER_BADGE_PHOTO_FULLSIZE_URL}${employee.login_name}`;
  const displayName = employee.displayName || employee.employee_name;
  const firstName = displayName.split(' ')[0];
  const location = [employee.location_city_name, formatStateName(employee.location_state_name)].filter(Boolean).join(', ');

  useEffect(() => {
    const el = badgeRef.current;
    if (el) VanillaTilt.init(el, tiltOptions);
    return () => {
      if (el && (el as any).vanillaTilt) {
        try {
          const tilt = (el as any).vanillaTilt;
          tilt.destroy();
          clearTimeout(tilt.transitionTimeout);
        } catch {
          /* noop */
        }
      }
    };
  }, []);

  return (
    <div className="hyper-badge-wrapper">
      <a href={generatePhoneToolUrl(employee.login_name)} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none' }}>
        <div className={`Badge _${color}`} ref={badgeRef}>
          <div className="Back" />
          <div className="HoleBack" />
          <div className="Card" />
          <div className="Photo" style={{ backgroundImage: `url('${photo}')` }} />
          <div className="FirstName">{firstName}</div>
          <div className="Username">{employee.login_name}@</div>
          <div className="Hole" />
          <div className="Border" />
          <div className="Highlight" />
        </div>
      </a>
      <div className="hyper-badge-details">
        {employee.job_level_name && <div className="hyper-badge-details__level">L{employee.job_level_name}</div>}
        {employee.job_title_name && <div className="hyper-badge-details__title">{employee.job_title_name}</div>}
        {employee.department_name_current && <div className="hyper-badge-details__department">{employee.department_name_current}</div>}
        {location && <div className="hyper-badge-details__location">{location}</div>}
      </div>
    </div>
  );
};
